import React from "react";
import { Wrapper, WrapperIcon } from "./styles";
import { Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";

export const ModalHeader = ({
  icon,
  title,
  subtitle,
  align,
  margin,
  padding,
  hasBorder,
  iconWidth,
  iconHeight,
  iconBackground,
  iconBorderColor,
  sizeTitle,
  colorTitle,
  weightTitle,
  ...rest
}) => {
  return (
    <Wrapper
      align={align}
      margin={margin}
      padding={padding}
      hasBorder={hasBorder}
      {...rest}
    >
      {icon && typeof icon === "string" && (
        <WrapperIcon
          iconBorderColor={iconBorderColor}
          style={{ background: iconBackground }}
        >
          <img alt="icon" src={icon} width={iconWidth} height={iconHeight} />
        </WrapperIcon>
      )}
      {icon && typeof icon !== "string" && (
        <WrapperIcon
          iconBorderColor={iconBorderColor}
          style={{ background: iconBackground }}
        >
          {icon}
        </WrapperIcon>
      )}
      {title && (
        <Text
          size={sizeTitle || theme.fonts.size.h4}
          color={colorTitle || theme.colors.gray950}
          weight={weightTitle || theme.fonts.weight.bold}
        >
          {title}
        </Text>
      )}
      {subtitle && (
        <Text size={theme.fonts.size.xs} color={theme.colors.dark}>
          {subtitle}
        </Text>
      )}
    </Wrapper>
  );
};
